// extracted by mini-css-extract-plugin
module.exports = {"Image500":"Image_Image500__1WGaX","Image720Area":"Image_Image720Area__2i2rM","Image720":"Image_Image720__3G7V7"};